module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-BoldItalic.4fdd27b2.otf";